import React, {useState} from "react";

export const OfficeConfiguration = ({submitWithoutStripe, currentDomain, renderErrorMessage, handleSubdomain, subdomain}) => {
    const [officeSize, setOfficeSize] = useState('25');


    const handleOfficeSize = (event) => {
        const target = event.target;
        const value = target.value;
        setOfficeSize(value);
    };


    return <div className={"step flexRowContainer"} id={"payment"}>
            <h3 className={"mb10"}>
                Almost there!
            </h3>
            Please take a moment to review and update your office size and qube url as necessary:
            <div className={"flexColumnContainer flexAlignCenter"}>
                <div
                    className="flexRowContainer mt20 mr40 width-100">
                    <input type="text" name="officeSize" required className="fancyInput"
                           value={officeSize}
                           onChange={handleOfficeSize}/>
                    <label alt='Office Size' placeholder='Office Size'/>
                </div>
                <div>https://</div>
                <div className="flexRowContainer mt20 ml8 mr8">
                    <input type="text" name="subdomain" required className="fancyInput"
                           value={subdomain}
                           onChange={handleSubdomain}/>
                    <label alt='qube url' placeholder='qube url'/>
                </div>
                <div>.{currentDomain}</div>
            </div>
            <div className={"flexColumnContainer"}>
                <div className={"flexFill"}/>
                <input type="button" className="btn setupBtn"
                       value="Submit"
                       onClick={() => submitWithoutStripe(officeSize, subdomain)}/>
            </div>
            {renderErrorMessage()}
        </div>

};
